import React from 'react';
import { useTranslation } from 'react-i18next';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';

import { Order } from '@rebound/shared-models/order/order.model';

import WarnIcon from '@components/WarnIcon';
import { anyItemWithinReturnWindow } from '@modules/return-journey/return-journey.utils';

type ReturnNotAvailableLabelProps = {
  order: Order;
  returnPolicyDays: number;
};

const ReturnNotAvailableLabel = ({
  order,
  returnPolicyDays,
}: ReturnNotAvailableLabelProps) => {
  const { t } = useTranslation();

  const hasReturnableFlaggedItem = order.items.some(
    (item) => !item.nonReturnable,
  );

  return (
    <ReturnNotAvailableInfo>
      <WarnIcon />
      <ReturnNotAvailableInfoText>
        <ReturnNotAvailableTitle>
          {t('ordersListing.returnCreationNotAvailableTitle') as string}
        </ReturnNotAvailableTitle>
        <ReturnNotAvailableReason>
          {hasReturnableFlaggedItem &&
          !(
            anyItemWithinReturnWindow(order, returnPolicyDays) ||
            Boolean(order.rma)
          )
            ? (t('ordersListing.creationUnavailablePolicyReason') as string)
            : (t('ordersListing.creationUnavailableItemsReason') as string)}
        </ReturnNotAvailableReason>
      </ReturnNotAvailableInfoText>
    </ReturnNotAvailableInfo>
  );
};

const ReturnNotAvailableInfo = styled.div`
  background-color: ${({ theme }) => theme.colors.warningYellow1};
  padding: 8px 12px;
  display: flex;

  ${up('sm')} {
    padding: 8px 24px;
    width: 340px;
  }

  ${up('lg')} {
    width: 456px;
  }
`;

const ReturnNotAvailableInfoText = styled.div`
  margin-left: 12px;
`;

const ReturnNotAvailableTitle = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #92400e;
`;

const ReturnNotAvailableReason = styled.p`
  margin-top: 8px;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.warningYellow2};
`;

export default ReturnNotAvailableLabel;
